import { RSS_SUBTITLE_LIMIT } from 'resources/show/schema';
import removeHtmlTags from 'shared/helpers/remove-html-tags';
import limitWithEllipsis from 'shared/helpers/limit-with-ellipsis';

export default function convertToRssSubtitle(str) {
  return limitWithEllipsis(removeHtmlTags(str), RSS_SUBTITLE_LIMIT);
}
